// @flow
import type { TestSchedule, Product as ProductType } from "../../lib/Types";
import React, { Fragment } from "react";
import styled from "styled-components";
import { DefaultContainer } from "./Theme";
import ScheduleList from "./ScheduleList";
import Expander from "../Expander";
import ProductBarcodes from "./ProductBarcodes";
import Button from "../Button";
import ProductSchedulesForm from "../products/ProductSchedulesForm";
import TestingProtocols from "./TestingProtocols";

const Header = styled.div`
  cursor: pointer;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 4px;
  padding-bottom: 4px;
  border-radius: 5px;
  user-select: none;
`;
const ProductContainer = styled(DefaultContainer)`
  margin-bottom: 4px;
  border-radius: 0px;
  ${Header}:hover {
    text-decoration: underline;
    background-color: #fafafa !important;
  }
`;

type Props = {
  product: ProductType,
  onlyPick: boolean,
  pickSchedule: Function,
  registerProtocol: Function,
  companyId: number,
  reload: Function,
  addSchedules: boolean,
};

type State = {
  expanded: boolean,
};

export default class Product extends React.Component<Props, State> {
  state = {
    expanded: this.props.initialExpanded || false,
    showBarcodeForm: false,
    showScheduleForm: false,
    showProtocols: false,
    scheduleGeneration: 1,
  };

  toggleExpand = () => this.setState({ expanded: !this.state.expanded });

  pickSchedule = (test_schedule, count) => {
    const { product } = this.props;
    this.props.pickSchedule({ product, test_schedule, count });
  };

  registerProtocol = (protocol_id) => {
    const { product } = this.props;
    this.props.registerProtocol({ product, protocol_id });
  };

  render() {
    const {
      product,
      showClientSuite,
      onlyPick,
      pickSchedule,
      companyId,
      reload,
      addSchedules,
    } = this.props;
    const {
      expanded,
      showBarcodeForm,
      showScheduleForm,
      scheduleGeneration,
      showProtocols,
    } = this.state;

    return (
      <ProductContainer>
        <Header onClick={this.toggleExpand}>
          <Expander expanded={expanded} />
          <span>{product.name}</span>
        </Header>
        {expanded && (
          <Fragment>
            <div className="btn-toolbar" style={{ paddingLeft: 20, paddingTop: 20 }}>
              <div className="btn-group">
                <Button
                  title="Add Barcode"
                  tiny
                  icon="fa-plus"
                  onClick={() => this.setState({ showBarcodeForm: !showBarcodeForm })}
                />
              </div>
              {addSchedules && (
                <div className="btn-group">
                  <Button
                    title="Add Schedule"
                    tiny
                    icon="fa-plus"
                    onClick={() => this.setState({ showScheduleForm: !showScheduleForm })}
                  />
                </div>
              )}
              <div className="btn-group">
                <Button
                  title="Register Protocol"
                  tiny
                  icon="fa-plus"
                  onClick={() => this.setState({ showProtocols: !showProtocols })}
                />
              </div>
            </div>
            {showBarcodeForm && (
              <ProductBarcodes
                product_id={product.id}
                isFormVisible={showBarcodeForm}
                closeForm={() => this.setState({ showBarcodeForm: false })}
              />
            )}
            {showScheduleForm && (
              <ProductContainer style={{ margin: 20 }}>
                <ProductSchedulesForm
                  product={product}
                  company_id={companyId}
                  ref={(ref) => (this.productScheduleForm = ref)}
                  toggleScheduleForm={() =>
                    this.setState({ showScheduleForm: !showScheduleForm })
                  }
                  reloadProduct={() =>
                    this.setState({ scheduleGeneration: scheduleGeneration + 1 })
                  }
                />
              </ProductContainer>
            )}
            {showProtocols && (
              <div
                className="basic-panel with-padding"
                style={{ marginTop: 20, marginBottom: 20 }}
              >
                <h4>Select Protocol</h4>
                <TestingProtocols
                  company_id={companyId}
                  registerProtocol={this.registerProtocol}
                  onClose={() => this.setState({ showModal: false })}
                />
              </div>
            )}
            <ScheduleList
              key={scheduleGeneration}
              product_id={product.id}
              onlyPick={onlyPick}
              pickSchedule={this.pickSchedule}
            />
          </Fragment>
        )}
      </ProductContainer>
    );
  }
}
